import React from 'react';
import type { ModuleValue } from '../types';
import MeasurementsModule from './measurements/MeasurementsModule';

export interface ModuleComponentProps {
  productIds: string[];
}

/**
 * Registry of Bulk Edit modules keyed by the Select Module value. Adding a module is a one-line
 * entry here; each module owns its own render-scoped state so switching modules stays isolated.
 * Partial by design — a module value may render outside this slot (design-details renders its own
 * grid in the page body), so a missing key means "not driven by the generic module slot".
 */
export const MODULE_REGISTRY: Partial<Record<ModuleValue, React.FC<ModuleComponentProps>>> = {
  measurements: MeasurementsModule,
};
